import { showToast } from "@/lib/utils/toast";
import { dataEntryService } from "../services/data-entry.services";
import { entryUIStore } from "../stores/entry-ui.store";
import { promiseWithMinDelay } from "@/lib/utils/promiseWithMinDelay";
import { loadDataEntries } from "./load.ops";

export const uploadAndAttachProofs = async (entry, companyId, files) => {
  const { setUpdatingEntry } = entryUIStore;
  setUpdatingEntry(true);

  try {
    const uploadPromise = dataEntryService.uploadProofFiles(companyId, files);

    showToast.promise(uploadPromise, {
      success: "Files uploaded",
      loading: "Uploading files",
      error: "Failed to upload files",
    });

    const uploaded = await promiseWithMinDelay(uploadPromise);
    if (!uploaded) return false;

    const newProofs = uploaded.map((f) => ({
      fileId: f._id,
      name: f.originalName,
      size: f.size,
      type: f.mimeType,
      url: f.url,
    }));

    const mergedProofs = [...(entry.proofs || []), ...newProofs];
    await dataEntryService.updateDataEntry(entry._id, {
      proofs: mergedProofs,
    });
    await loadDataEntries();
    entryUIStore.setProofEntry({ ...entry, proofs: mergedProofs });
    return true;
  } catch {
    return false;
  } finally {
    setUpdatingEntry(false);
  }
};

export const removeProof = async (entry, fileId) => {
  const { setUpdatingEntry } = entryUIStore;
  setUpdatingEntry(true);

  try {
    const filtered = (entry.proofs || []).filter(
      (p) => p.fileId?.toString() !== fileId?.toString(),
    );

    const updatePromise = dataEntryService.updateDataEntry(entry._id, {
      proofs: filtered,
    });

    showToast.promise(updatePromise, {
      success: "Proof removed",
      loading: "Removing proof",
      error: "Failed to remove proof",
    });

    await promiseWithMinDelay(updatePromise);
    dataEntryService.deleteProofFile(fileId).catch(() => {});
    await loadDataEntries();
    entryUIStore.setProofEntry({ ...entry, proofs: filtered });
    return true;
  } catch {
    return false;
  } finally {
    setUpdatingEntry(false);
  }
};
